import React, { useState, useEffect } from "react";
import supabase from "../../lib/supabase";
export default function ClientMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const { data, error } = await supabase
          .from("client_messages")
          .select("id,name,email,message,status,created_at")
          .order("created_at", { ascending: false });
        if (error) throw error;
        setMessages(data || []);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetchMessages();
  }, []);

  const onClickDelete = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    console.log(deleteId);
    if (!deleteId) return;
    try {
      const { data, error } = await supabase
        .from("client_messages")
        .delete()
        .eq("id", deleteId);
      console.log(data, error);
      if (error) throw error;
      setMessages((prev) => prev.filter((m) => m.id !== deleteId));
    } catch (e) {
      console.error(e);
    } finally {
      setDeleteId(null);
      setConfirmOpen(false);
    }
  };

  return (
    <div className="overflow-x-auto flex justify-center">
      <div className="w-full max-w-6xl">
        <table className="w-full bg-gray-900 text-white border border-gray-700 rounded-lg shadow-lg">
          <thead className="bg-gray-800">
            <tr className="text-left">
              <th className="py-4 px-6 border-b border-gray-700 w-12">#</th>
              <th className="py-4 px-6 border-b border-gray-700 w-48">Name</th>
              <th className="py-4 px-6 border-b border-gray-700 w-64">Email</th>
              <th className="py-4 px-6 border-b border-gray-700 w-auto">
                Message
              </th>
              <th className="py-4 px-6 border-b border-gray-700 w-40">
                Timestamp
              </th>
              <th className="py-4 px-6 border-b border-gray-700 w-32 text-center">
                Status
              </th>
              <th className="py-4 px-6 border-b border-gray-700 w-24 text-center">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-400">
                  Loading...
                </td>
              </tr>
            ) : messages.length > 0 ? (
              messages.map((msg, index) => (
                <tr key={msg.id} className="hover:bg-gray-800">
                  <td className="py-3 px-6 border-b border-gray-700">
                    {index + 1}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700">
                    {msg.name}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700">
                    {msg.email}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700">
                    {msg.message}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700">
                    {msg.created_at
                      ? new Date(msg.created_at).toLocaleString()
                      : "-"}
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700 text-center">
                    <span
                      className={`px-3 py-1 rounded-md text-xs font-semibold ${
                        msg.status === "Read"
                          ? "bg-green-500 text-white"
                          : "bg-red-500 text-white"
                      }`}
                    >
                      {msg.status || "New"}
                    </span>
                  </td>
                  <td className="py-3 px-6 border-b border-gray-700 text-center">
                    <button
                      className="px-2 py-1 bg-red-600 rounded"
                      onClick={() => onClickDelete(msg.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-6 text-gray-400">
                  No messages found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {confirmOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setConfirmOpen(false)}
          />
          <div className="relative z-10 w-full max-w-md bg-gray-900 text-white p-6 rounded-lg border border-gray-700">
            <h4 className="text-lg mb-2">Delete Message</h4>
            <p className="mb-4">
              Are you sure you want to delete this message? This action cannot
              be undone.
            </p>
            <div className="flex items-center justify-end gap-2">
              <button
                className="px-4 py-2 bg-gray-700 rounded"
                onClick={() => setConfirmOpen(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-600 rounded"
                onClick={confirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
